import React, { useEffect, useState, useRef, forwardRef } from 'react'
import { ChevronDown, ChevronUp } from '../NewIcons'

const Accordion = forwardRef(
  (
    {
      placeholder,
      children,
      size,
      placeholderEllipses,
      withoutBorder,
      className,
      id,
      // Controlled props
      open: controlledOpen,
      onToggle,
      // Uncontrolled prop
      defaultOpen = false,
    },
    ref
  ) => {
    const localRef = useRef(null)
    const accordionRef = ref || localRef

    const isControlled = controlledOpen !== undefined

    // Internal state for uncontrolled mode
    const [internalOpen, setInternalOpen] = useState(defaultOpen)

    // Determine the current open state
    const isOpen = isControlled ? controlledOpen : internalOpen

    const handleToggle = () => {
      if (isControlled) {
        // For controlled components, call the passed-in handler
        onToggle?.(!isOpen)
      } else {
        // For uncontrolled components, update the internal state
        setInternalOpen((prevOpen) => !prevOpen)
      }
    }

    useEffect(() => {
      if (!isControlled) setInternalOpen(defaultOpen)
    }, [defaultOpen])

    return (
      <div
        ref={accordionRef}
        id={id}
        className={
          `accordion accordion--${size ? size : 'large'}` +
          `${!withoutBorder ? ' accordion--with-border' : ''}` +
          `${placeholderEllipses ? ' accordion--placeholder-ellipses' : ''}` +
          `${className ? ' ' + className : ''}`
        }
      >
        <div className="accordion__container" onClick={handleToggle}>
          <p className="accordion__placeholder">{placeholder ? placeholder : 'Accordion'}</p>
          <div className="accordion__arrow">{isOpen ? <ChevronUp /> : <ChevronDown />}</div>
        </div>

        {isOpen && <div className="accordion__children">{children}</div>}
      </div>
    )
  }
)

export default Accordion
